import * as React from 'react';

import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CancelDripSequenceForEntity as CancelDripSequenceForEntityMutation,
    CancelDripSequenceForEntityVariables as CancelDripSequenceForEntityMutationVariables,
} from 'nutshell-graphql-types';

import CANCEL_DRIP_PROGRESSION from '../../../../email-marketing/drip-sequences/recipient-modal/graphql/mutations/cancel-drip-sequence-for-entity.graphql';

export const useCancelDripProgression = (): {
    cancelDripProgression: (dripProgressionId: string) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [cancelDripProgressionMutation, {loading, error}] = useMutation<
        CancelDripSequenceForEntityMutation,
        CancelDripSequenceForEntityMutationVariables
    >(CANCEL_DRIP_PROGRESSION);

    const cancelDripProgression = React.useCallback(
        (dripProgressionId: string) => {
            return cancelDripProgressionMutation({
                variables: {
                    dripProgressionDeleteInput: {
                        dripProgressionId,
                    },
                },
            });
        },
        [cancelDripProgressionMutation]
    );

    return {
        cancelDripProgression,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
